import { Role } from "../../helpers/role";

export const DealerRetailerRoutes = [
  {
    name: "DRS_DealerRoutes",
    path: `/${Role.DealerRetailer}`,
    redirect: "/",
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "DRS_DealerRetailerHome",
        path: "/",
        component: () => import("@/views/dealer-retailer/Home"),
        meta: {
          authorize: [Role.DealerRetailer],
        },
      },
      {
        name: "DRS_DealerRetailer",
        path: "retailer-dealer",
        component: () => import("@/views/dealer-retailer/DealerRetailer"),
        meta: {
          authorize: [Role.DealerRetailer],
        },
      },

      {
        name: "DRS_PerArea",
        path: "per-area",
        component: () => import("@/views/dealer-retailer/PerArea"),
        meta: {
          authorize: [Role.DealerRetailer],
        },
      },

      {
        name: "DRS_DealerSignUp",
        path: "pay-later",
        component: () => import("@/views/dealer/SignUp"),
        meta: {
          authorize: [Role.Dealer],
        },
      },
      {
        name: "DRS_DealerForInstallation",
        path: "for-installation",
        component: () => import("@/views/dealer/ForInstallation"),
        // component: () => import("@/views/acquisition/components/signups_components/ForInstallation"),
        
        meta: {
          authorize: [Role.Dealer],
        },
      },
      {
        name: "DRS_DealerInstalledActivated",
        path: "installed-activated",
        component: () => import("@/views/dealer/InstalledActivated"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerReportSignUp",
        path: "report-sign-up",
        component: () => import("@/views/dealer/ReportSignUp"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerReportInstallation",
        path: "report-installation",
        component: () => import("@/views/dealer/ReportInstallation"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerReportTopUp",
        path: "monthly-sales",
        component: () => import("@/views/dealer/ReportTopUp"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerIbasUserList",
        path: "ibas-user-list",
        component: () => import("@/views/dealer/IbasUserList"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerForConfirmation",
        path: "for-confirmation",
        component: () => import("@/views/dealer/ForConfirmation"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerRetailerList",
        path: "retailers",
        component: () => import("@/views/dealer/RetailerList"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerSubribriberList",
        path: "subscribers",
        component: () => import("@/views/acquisition/Subscribers"),
        meta: {
          authorize: [Role.Dealer],
        },
      },

      {
        name: "DRS_DealerSalesReport",
        path: "sales-report",
        component: () => import("@/views/dealer/RetailerSalesReport"),
        meta: {
          authorize: [Role.Dealer],
        },
      },
    ],
  },
];
